const config = {
    env: "dev",
  // url : "https://nice-node-deploy.herokuapp.com",  //Dev Url
     url : "https://gradapi.biswaroop.com",  //Prod Url
    logLevel: 2,
  };
  
  export default config;